<script setup>
import { useAttrs } from 'vue';
import cacoCreativoSymbol from 'dashboard/assets/images/caco-creativo-symbol.png';

const attrs = useAttrs();
</script>

<template>
  <img v-once v-bind="attrs" :src="cacoCreativoSymbol" alt="Caco Creativo" />
</template>
